// import { fetchRepos } from "./data";
import { fetchScreenshot } from "./data";
import images from "/src/js/images.js";

const projectsDiv = document.querySelector(".project-cards");

export function showError(string) {
  projectsDiv.innerHTML = "";
  projectsDiv.textContent = string;
}

export async function displayProject(project) {
  const card = `<img src="https://api.screenshotone.com/take?url=${project.homepage}&access_key=Kpoq6ALp7Y5blA&&cache=true&&cache_ttl=700000" alt="" class="project-screenshot">
    <div class="project-menu">
        <h3>${project.name}</h3>
        <div class="project-icons">
        <a href="${project.html_url}"><img src="${images["github-circle.svg"]}" alt=""></a>
            <a href="${project.homepage}" target="_blank"><img src="${images["open-in-new.svg"]}" alt=""></a>
        </div>
    </div>
    <p>${project.description}</p>`;

  const projectCard = document.createElement("div"),
    topicsDiv = document.createElement("div");

  for (let topic of project.topics) {
    const topicSpan = document.createElement("span");
    topicSpan.textContent = topic;
    topicsDiv.append(topicSpan);
  }
  topicsDiv.classList.add("project-topics");
  projectCard.classList.add("project-card");
  projectCard.innerHTML = card;
  projectCard.append(topicsDiv);
  projectsDiv.append(projectCard);
}
